document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('media-gallery').forEach(function (gallery) {
    var prevBtn = gallery.querySelector('.slider-mobile-gutter .slider-button--prev');
    var nextBtn = gallery.querySelector('.slider-mobile-gutter .slider-button--next');
    var thumbnails = gallery.querySelector('[id^="GalleryThumbnails-"]');

    if (!prevBtn || !nextBtn || !thumbnails) return;

    function getThumbButtons() {
      return Array.prototype.slice.call(thumbnails.querySelectorAll('.thumbnail-list__item button'));
    }

    function goToOffset(offset) {
      var buttons = getThumbButtons();
      if (!buttons.length) return;

      var currentIndex = buttons.findIndex(function (button) {
        return button.getAttribute('aria-current') === 'true';
      });
      if (currentIndex === -1) currentIndex = 0;

      var nextIndex = currentIndex + offset;
      if (nextIndex < 0) nextIndex = buttons.length - 1;
      if (nextIndex >= buttons.length) nextIndex = 0;

      buttons[nextIndex].click();
    }

    function isDesktop() {
      return window.matchMedia('(min-width: 750px)').matches;
    }

    prevBtn.addEventListener('click', function (event) {
      // On mobile, Dawn's native scroll-based navigation already works —
      // only step in on desktop, where the main slides are display:none
      // and scrolling the list does nothing.
      if (isDesktop()) {
        event.preventDefault();
        event.stopPropagation();
        goToOffset(-1);
      }
    });

    nextBtn.addEventListener('click', function (event) {
      if (isDesktop()) {
        event.preventDefault();
        event.stopPropagation();
        goToOffset(1);
      }
    });
  });
});